<template>
  <transition
    name="slide"
    mode="out-in"
  >
    <account-form
      mode="new_visit"
      @confirmed="setConfirmed($event)"
    />
  </transition>
</template>

<script>
import AccountForm from '~/AccountForm';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    AccountForm,
  },
  data() {
    return {
      confirmed: false,
    };
  },
  computed: {
    ...mapGetters({
      buttonColor: 'brand/getThirdColor',
      myCars: 'myCars/getMyCars',
      allCars: 'brand/getSpecificModels',
      primaryColor: 'brand/getPrimaryColor',
    }),
    withoutLogin() {
      return this.$route.path.includes('no_auth');
    },
    carID() {
      if (!this.withoutLogin) {
        return this.$route.params.id;
      }
      return null;
    },
  },
  methods: {
    ...mapActions({
      loadSavedData: 'visit/loadSavedData',
    }),
    setConfirmed(event) {
      const isEdit = this.$route.path.includes('edit');

      if (event) {
        if (this.withoutLogin) {
          this.$router.push({ path: '/no_auth/visit/confirmed' });
        } else if (this.carID) {
          if (isEdit) {
            this.$router.push({ path: `/dashboard/visits/edit/${this.carID}/confirmed` });
          } else {
            this.$router.push({ path: `/dashboard/visits/new/${this.carID}/confirmed` });
          }
        }
      }
    },
  },
  mounted() {
    this.loadSavedData();
  },
};
</script>
